var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAlignTopIcon = function SvgAlignTopIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h36v34H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "#545454"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7.75H27v9.5h-7.5v-9.5zM9 7.75h7.5v17.5H9V7.75z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 7.75v9.5h-7.5v-9.5H27zm-1.5 1.5H21v6.5h4.5v-6.5zm-9-1.5v17.5H9V7.75h7.5zM15 9.25h-4.5v14.5H15V9.25z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M29.5 4.25v2h-23v-2z"
  })))));
};

export default SvgAlignTopIcon;